export default "__VITE_ASSET__nX1J9Eyy__"